import { render, staticRenderFns } from "./SuccessResetPasswordScreen.vue?vue&type=template&id=4408f029&scoped=true&"
import script from "./SuccessResetPasswordScreen.vue?vue&type=script&lang=js&"
export * from "./SuccessResetPasswordScreen.vue?vue&type=script&lang=js&"
import style0 from "./SuccessResetPasswordScreen.vue?vue&type=style&index=0&id=4408f029&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4408f029",
  null
  
)

export default component.exports